// extracted by mini-css-extract-plugin
export default {"qbSection":"qb-section__i92kdjuG"};